import './Footer.css';

const InstagramIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path d="M16 11.37a4 4 0 11-2.63-3.74 4 4 0 012.63 3.74z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
  </svg>
);
const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
  </svg>
);
const MailIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <a className="footer-logo" href="/" aria-label="Go to home page">
          <img className="footer-logo-image" src="/images/logo.png" alt="Logo" />
        </a>
        <p className="footer-copy">© 2026 Talha Khalid Portfolio. All rights reserved. Built with precision.</p>
        <div className="footer-icons">
          <a href="https://www.instagram.com/talha_._khalid" target="_blank" rel="noreferrer" className="footer-icon instagram-icon"><InstagramIcon /></a>
          <a href="https://github.com/Talha-Khalid-D" target="_blank" rel="noreferrer" className="footer-icon"><GithubIcon /></a>
          <a href="mailto:talhakhaliddhariwal@gmail.com" className="footer-icon"><MailIcon /></a>
        </div>
      </div>
    </footer>
  );
}
